import { Megaphone, UserX, RotateCcw } from "lucide-react";
import { Reveal, SplitLines } from "@/components/fx/Reveal";

const PAINS = [
  { icon: Megaphone, title: "L'annuncio non porta nessuno", text: "Hai aperto la ricerca da mesi, arrivano pochi CV fuori target. Le persone brave un lavoro ce l'hanno già e gli annunci non li leggono." },
  {
    icon: UserX, title: "Il candidato sparisce", text: "Colloquio andato bene, lo richiami dopo una settimana e ha già firmato altrove.",
    seq: ["Arriva una candidatura interessante", "Il colloquio va bene", "Passano giorni. Poi settimane", "Ha già firmato altrove"],
    extra: "Il mercato non aspetta: i profili più forti restano disponibili poco tempo.",
  },
  { icon: RotateCcw, title: "L'assunzione sbagliata", text: "Sul CV era perfetto, dopo due mesi capisci che non va. Stipendi pagati, team sotto pressione, si ricomincia." },
];

export const Problem = () => (
  <section id="problema" className="rl-section relative py-28 lg:py-40" data-testid="problem-section">
    <div className="rl-container">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="rl-eyebrow text-[#0F6E56]">Il problema</p>
        </div>
        <SplitLines
          className="rl-h2 lg:col-span-8"
          lines={["Se cerchi personale,", "probabilmente ti è", "già successo."]}
          data-testid="problem-title"
        />
      </div>
      <div className="mt-16 grid gap-5 md:grid-cols-3 lg:mt-24 lg:gap-6">
        {PAINS.map((p, i) => (
          <Reveal key={p.title} delay={i * 120} className="rl-fade">
            <article className="rl-card group relative h-full overflow-hidden p-7 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:border-[#BCE3D6] hover:shadow-[0_30px_60px_-30px_rgba(15,110,86,0.35)] sm:p-9" data-testid={`problem-card-${i}`}>
              <div className="flex items-center justify-between">
                <span className="font-mono-data text-sm text-[#6B6961]">0{i + 1}</span>
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-[#F7F6F2] text-[#0F6E56] transition-transform duration-500 group-hover:rotate-[-12deg] group-hover:scale-110">
                  <p.icon size={20} />
                </span>
              </div>
              <h3 className="mt-14 text-2xl leading-tight tracking-[-0.02em]">{p.title}</h3>
              <p className="mt-4 text-[15.5px] leading-relaxed text-[#2C2C2A]/80">{p.text}</p>
              {p.seq && (
                <ol className="mt-6 space-y-2.5 border-t border-[#E7E5DF] pt-5" data-testid="problem-ghost-sequence">
                  {p.seq.map((s, k) => (
                    <li key={s} className={`flex items-center gap-3 text-[14px] ${k === p.seq.length - 1 ? "font-medium text-[#2C2C2A]" : "text-[#2C2C2A]/75"}`}>
                      <span className={`inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full font-mono-data text-[11px] ${k === p.seq.length - 1 ? "bg-[#2C2C2A] text-white" : "bg-[#F7F6F2] text-[#6B6961]"}`}>{k + 1}</span>
                      {s}
                    </li>
                  ))}
                </ol>
              )}
              {p.extra && <p className="mt-5 rounded-xl bg-[#BCE3D6]/35 px-4 py-3 text-[14px] leading-snug text-[#13352F]" data-testid="problem-market-note">{p.extra}</p>}
              <span className="absolute bottom-0 left-0 h-[3px] w-full origin-left scale-x-0 bg-[#0F6E56] transition-transform duration-700 group-hover:scale-x-100" />
            </article>
          </Reveal>
        ))}
      </div>
      <Reveal className="rl-fade mt-24 lg:mt-36">
        <p className="rl-display max-w-[1100px] text-[clamp(1.9rem,4.4vw,4rem)] leading-[1.05]" data-testid="problem-closing">
          <span className="text-[#6B6961]">Non è sfortuna e non è il mercato.</span>{" "}
          <span className="text-[#2C2C2A]">È il processo che manca.</span>
        </p>
      </Reveal>
    </div>
  </section>
);
